var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn-toggle',[_c('v-btn',{staticClass:"excel-btn",attrs:{"title":"Download in .xls format. This option required microsoft excel install on the device"},on:{"click":function($event){return _vm.exportToFile(_vm.data,_vm.fileName,'xls')}}},[_c('v-icon',{staticClass:"icon-color"},[_vm._v("mdi-microsoft-excel")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }